import React from 'react';
import { Link } from 'react-router-dom';
import { Mail, Phone, MapPin, Linkedin, Facebook, Instagram } from 'lucide-react';

const Footer = () => {
  return (
    <footer className="bg-[#1a1a1a] text-white">
      <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-16">
        <div className="grid grid-cols-1 md:grid-cols-4 gap-12">
          <div className="col-span-1 md:col-span-2">
            <img
              src="https://customer-assets.emergentagent.com/job_talent-nexus-37/artifacts/rmnir4c5_Nexor%20-%20sans%20fond%20blanc%20-%20png.png"
              alt="Nexor Talents"
              className="h-12 w-auto mb-6"
            />
            <p className="text-gray-300 text-sm mb-4 max-w-md leading-relaxed">
              Là où les parcours prennent vie. Là où les équipes prennent de la hauteur.
            </p>
            <p className="text-gray-400 text-sm leading-relaxed">
              Votre partenaire stratégique pour un recrutement plus humain, plus intelligent et plus durable.
            </p>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-gold">Navigation</h3>
            <ul className="space-y-3">
              <li>
                <Link to="/" className="text-gray-300 hover:text-gold transition-colors text-sm">
                  Accueil
                </Link>
              </li>
              <li>
                <Link to="/a-propos" className="text-gray-300 hover:text-gold transition-colors text-sm">
                  À propos
                </Link>
              </li>
              <li>
                <Link to="/recrutement" className="text-gray-300 hover:text-gold transition-colors text-sm">
                  Recrutement
                </Link>
              </li>
              <li>
                <Link to="/formations" className="text-gray-300 hover:text-gold transition-colors text-sm">
                  Formations
                </Link>
              </li>
              <li>
                <Link to="/equipe" className="text-gray-300 hover:text-gold transition-colors text-sm">
                  Notre équipe
                </Link>
              </li>
              <li>
                <Link to="/faq" className="text-gray-300 hover:text-gold transition-colors text-sm">
                  FAQ
                </Link>
              </li>
              <li>
                <Link to="/ressources" className="text-gray-300 hover:text-gold transition-colors text-sm">
                  Ressources
                </Link>
              </li>
              <li>
                <Link to="/politiques" className="text-gray-300 hover:text-gold transition-colors text-sm">
                  Politiques
                </Link>
              </li>
            </ul>
          </div>

          <div>
            <h3 className="text-lg font-semibold mb-4 text-gold">Contact</h3>
            <ul className="space-y-3">
              <li className="flex items-start space-x-3">
                <Mail className="w-5 h-5 text-gold mt-0.5 flex-shrink-0" />
                <a href="mailto:info@nexortalents.com" className="text-gray-300 hover:text-gold transition-colors text-sm break-all">
                  info@nexortalents.com
                </a>
              </li>
              <li className="flex items-start space-x-3">
                <Phone className="w-5 h-5 text-gold mt-0.5 flex-shrink-0" />
                <span className="text-gray-300 text-sm">514-545-3383</span>
              </li>
              <li className="flex items-start space-x-3">
                <MapPin className="w-5 h-5 text-gold mt-0.5 flex-shrink-0" />
                <span className="text-gray-300 text-sm">Basé au Québec</span>
              </li>
            </ul>
            
            <div className="flex space-x-4 mt-6">
              <a href="#" className="text-gray-300 hover:text-gold transition-colors">
                <Linkedin className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-gold transition-colors">
                <Facebook className="w-5 h-5" />
              </a>
              <a href="#" className="text-gray-300 hover:text-gold transition-colors">
                <Instagram className="w-5 h-5" />
              </a>
            </div>
          </div>
        </div>

        <div className="border-t border-gray-800 mt-12 pt-8 text-center">
          <p className="text-gray-400 text-sm">
            © {new Date().getFullYear()} Nexor Talents. Tous droits réservés.
          </p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;